export default "__VITE_ASSET__Cev9gqMH__"